import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RoutesComponent } from './routes/routes.component';
import { BusesRoutingModule } from './buses-routing.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { BusStudentsComponent } from './bus-students/bus-students.component';
import { SharedModule } from '../shared/shared.module';
import { BusTrackingComponent } from './bus-tracking/bus-tracking.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { ColorPickerModule } from 'ngx-color-picker';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CreateRouteComponent } from './create-route/create-route.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EnrollStudentsBusesSystemComponent } from './enroll-students-buses-system/enroll-students-buses-system.component';
import { SubscriptionRequestsComponent } from './subscription-requests/subscription-requests.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { EnrollErrorsComponent } from './enroll-students-buses-system/enroll-errors/enroll-errors.component';
import { EnrollDetailsComponent } from './enroll-students-buses-system/enroll-details/enroll-details.component';
import { TabMenuModule } from 'primeng/tabmenu';
import { UploadEnrollFileComponent } from './bulk-enroll/bulk-enroll-steps/upload-enroll-file/upload-enroll-file.component';
import { EnrollColumnMappingComponent } from './bulk-enroll/bulk-enroll-steps/enroll-column-mapping/enroll-column-mapping.component';
import { EnrollFixErrorsComponent } from './bulk-enroll/bulk-enroll-steps/enroll-fix-errors/enroll-fix-errors.component';
import { AssignTripsComponent } from './bulk-enroll/bulk-enroll-steps/assign-trips/assign-trips.component';
import { StepperComponent } from './bulk-enroll/stepper/stepper.component';
import { ValidationErrorsComponent } from './bulk-enroll/validation-errors/validation-errors.component';
import { ColumnErrorsComponent } from './bulk-enroll/column-errors/column-errors.component';
import {MatProgressBarModule} from '@angular/material/progress-bar'



@NgModule({
  declarations: [
    RoutesComponent,
    BusStudentsComponent,
    BusTrackingComponent,
    CreateRouteComponent,
    EnrollStudentsBusesSystemComponent,
    SubscriptionRequestsComponent,
    EnrollErrorsComponent,
    EnrollDetailsComponent,
    UploadEnrollFileComponent,
    EnrollColumnMappingComponent,
    EnrollFixErrorsComponent,
    AssignTripsComponent,
    StepperComponent,
    ValidationErrorsComponent,
    ColumnErrorsComponent,
  ],
  imports: [
    CommonModule,
    ColorPickerModule,
    BusesRoutingModule,
    NgbTooltipModule,
    MatMenuModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    InfiniteScrollModule,
    TabMenuModule,
    MatProgressBarModule
  ]
})
export class BusesModule { }
